import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checkAndCompleteTask", "children", "task"];
import OpenModalButton from '../../button/OpenModalButton';
import ManualDetectedTaskComponent from './ManualDetectedTaskComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualDetectedTaskButton = _ref => {
  let {
      checkAndCompleteTask,
      children,
      task
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(OpenModalButton, Object.assign({
    onModalClose: () => void checkAndCompleteTask(task.key),
    text: children
  }, passThroughProps, {
    children: /*#__PURE__*/_jsx(ManualDetectedTaskComponent, {
      task: task
    })
  }));
};
export default ManualDetectedTaskButton;